import { useTranslation } from 'react-i18next';

function Footer() {
  const { t } = useTranslation();

  return (
    <>
      <footer>
        <div className="container">
          <div className="footer-content">
            <ul className="footer-content__1">
              <li>
                EX<span>VR</span>TISE
              </li>
              <li>{t('footer.address')}</li>
              <li>
                <a href="tel:+9023270003603">
                  <i className="fa-solid fa-phone"></i> &nbsp; 0232 700 0360
                </a>
              </li>
              <li>
                <a href="mailto:info@exvrtise.com">
                  <i className="fa-solid fa-envelope"></i>
                  &nbsp; info@mytekas.com
                </a>
              </li>
            </ul>

            <ul className="footer-content__2">
              <li>{t('footer.company')}</li>
              <li><a href="#home">{t('footer.links.gallery')}</a></li>
              <li><a href="#home">{t('footer.links.career')}</a></li>
              <li><a href="#home">{t('footer.links.mobile')}</a></li>
              <li><a href="#home">{t('footer.links.blog')}</a></li>
              <li><a href="#home">{t('footer.links.howWeWork')}</a></li>
            </ul>

            <ul className="footer-content__2">
              <li>{t('footer.subscribe.title')}</li>
              <li>
                <p>{t('footer.subscribe.description')}</p>
              </li>
              <li>
                <input type="email" placeholder={t('footer.subscribe.placeholder')}></input>
              </li>
              <li>
                <button className="submit-email">{t('footer.subscribe.button')}</button>
              </li>
            </ul>
          </div>
        </div>
      </footer>
    </>
  );
}

export default Footer;
